module.exports = __webpack_public_path__ + "static/media/82024c3c-126f-45c0-9929-bcabdd590bd4.8a80411c.JPG";